import create from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

export const lmpStore = create((set) => ({
  lmpPlannerCancelledSession: emptyObject,
  cancelPlannerLmpSession: (goalUID, sessionUID, refunded) =>
    set((state) => ({
      ...state,
      lmpPlannerCancelledSession: {
        ...state.lmpPlannerCancelledSession,
        [goalUID]: {
          ...state.lmpPlannerCancelledSession[goalUID],
          [sessionUID]: {
            isCancelled: true,
            isRefunded: refunded
          }
        }
      }
    })),
  clearCancelPlannerLmpSession: (goalUID, sessionUID) =>
    set((state) => ({
      ...state,
      lmpPlannerCancelledSession: {
        ...state.lmpPlannerCancelledSession,
        [goalUID]: {
          ...state.lmpPlannerCancelledSession[goalUID],
          [sessionUID]: {}
        }
      }
    }))
}));

const useLmpStore = createHook(lmpStore);

export default useLmpStore;
